import { useTranslation } from 'next-i18next'
import { Box, Heading } from '@machobear/design-system'

import { Listing } from '@/types'
import structure from '@/structure'
import List from '@/features/ListingsList/list'

interface Props {
  data: Listing[]
}

const transformSimilarListings = (listings: Listing[]): Listing[] => {
  return listings.map(listing => {
    if (listing.search_deals) {
      return listing
    }

    const search_deals: string[] = []

    if (
      listing.previous_price &&
      listing.price_change_status === 'price_down'
    ) {
      search_deals.push('price_drop')
    }

    if (
      listing.listing_deal?.description &&
      listing.listing_deal.description.length > 0
    ) {
      search_deals.push('special_offer')
    }

    return {
      ...listing,
      search_deals
    }
  })
}

const SimilarListings: React.FC<Props> = ({ data }) => {
  const { t } = useTranslation()

  const transformedData = transformSimilarListings(data)

  return data && !!data.length ? (
    <Box width="full" style={{ maxWidth: `${structure.page.width}px` }}>
      <Heading level="4">
        {t(
          'listing:b.similar_listings.view.similar_listings.title',
          'Similar Listings for Rent'
        )}
      </Heading>

      <List listings={transformedData} noSchema />
    </Box>
  ) : null
}

export default SimilarListings
